export default __webpack_public_path__ + "static/media/cashoutSFX.39c47b9e.mp3";